import axios from '../internal/axios';
export var getNewsList = function getNewsList() {
  return axios.get("/news").then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var getNewsById = function getNewsById(newsId) {
  return axios.get("/news/".concat(newsId)).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;

    if (error.response && error.response.status === 404) {
      return {
        error: 404
      };
    }

    return {
      error: message
    };
  });
};